<div class="article">
  <div class="menu d-none d-lg-block">
    <div class="summary">
      <div #summarymenu>
        @for (sum of summary; track sum) {
          <a routerLink="." (click)="scrollTo(sum, $index)"
            [class.active]="activeIndex == $index" [ngClass]="sum.tag">
            {{ sum.text }}
          </a>
        }
      </div>
    </div>
  </div>
  <div>
    <div class="content pe-5 ps-5 pt-4 pb-4">
      <h1 #maintitle id="maintitle">{{ article.title.rendered | urldecode }}</h1>
      <div #display [innerHTML]="article.content.rendered | urldecode"></div>
    </div>
    @if (showFooter) {
      <div class="d-none d-lg-flex faq-bottom justify-content-around align-items-end">
        <span>Nous espérons que cet article vous a été utile.</span>
        <a routerLink="/">Retourner à l'accueil</a>
        <a (click)="doGoBack()" [routerLink]="[]">Retourner à la FAQ</a>
      </div>
    }
  </div>
</div>
